import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageAPL9 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Clairefontaine",
            author: "footballgirl",
               date: "Fevrier, 2026",
            image: "images/apl/9a.jpg",
            content: `<h2>Clairefontaine: France’s National Training Centre and Elite Academy</h2>

<p>The venue for this fixture was INF Clairefontaine (Institut National du Football de Clairefontaine), France’s flagship national football centre located in Clairefontaine-en-Yvelines, around 50 km southwest of Paris in the Rambouillet forest.</p>

<p>Opened in 1988 and named after former FFF president Fernand Sastre, the 56-hectare site combines elite youth academy training (primarily for 13–15-year-olds from the Paris region, with full boarding, schooling, and technical/tactical/psychological development at no cost to families) with serving as the official training base and preparation camp for all French senior and youth national teams — including men’s, women’s, and U23 squads.</p>

<p>It features multiple grass and artificial pitches (including a main stadium pitch), medical facilities, gyms, a restaurant, and more. Clairefontaine rose to global fame as the base for the 1998 FIFA World Cup-winning French team and has produced icons such as Thierry Henry, Kylian Mbappé, Nicolas Anelka, and many others.</p>

<p>For the women’s pathway, it plays a key role in preparing talents for senior Les Bleues call-ups and professional breakthroughs in the Arkema Première Ligue, making it the perfect high-level setting for this U23 European Competition clash.</p>
<h2>克莱枫丹：法国国家训练中心与精英学院</h2>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>

<p>本场比赛的场地是INF克莱枫丹（Institut National du Football de Clairefontaine），即法国旗舰国家足球中心，位于克莱枫丹-伊夫林（Clairefontaine-en-Yvelines），距离巴黎西南约50公里，坐落在朗布依埃森林中。</p>

<p>该中心于1988年启用，以前法国足球联合会（FFF）主席费尔南·萨斯特（Fernand Sastre）的名字命名，占地56公顷。它结合了精英青年学院训练（主要针对来自巴黎地区的13–15岁球员，提供全寄宿、学校教育以及技术/战术/心理发展，对家庭免费）与作为所有法国成年和青年国家队（包括男子、女子和U23队）的官方训练基地和备战营地。</p>

<p>设施包括多个天然草皮和人造草皮球场（包括主体育场球场）、医疗设施、健身房、餐厅等。克莱枫丹因作为1998年FIFA世界杯冠军法国队的训练基地而闻名全球，并培养出了蒂埃里·亨利（Thierry Henry）、基利安·姆巴佩（Kylian Mbappé）、尼古拉斯·阿内尔卡（Nicolas Anelka）等众多球星。</p>

<p>在女子足球路径上，它在为高级法国女足（Les Bleues）征召和在阿克玛法国超级联赛（Arkema Première Ligue）实现职业突破方面发挥关键作用，使其成为这场U23欧洲赛事对决的完美高水平场地。</p>`,
            navIndices: { prev: 'apl-8', next: 'dfb-1' }
        });
    }

    init() {
        console.log('ArticlePageAPL9 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to APL
            `;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'apl' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_apl.png';
            leagueLogo.alt = 'APL';
        }
    }
}